import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../assets/images/logo.png';
import '../css/header.css'; // Import the custom CSS for the header


function Header() {
  return (
    <Navbar expand="lg" variant="light" className="navbar-custom fixed-top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={logo} alt="Pursync Logo" className="logo-img" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="nav-link-custom">Home</Nav.Link>
            <Nav.Link as={Link} to="/about-us" className="nav-link-custom">About Us</Nav.Link>
            <Nav.Link as={Link} to="/vision" className="nav-link-custom">Vision</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
